const SOSMED = {
  instagram: 'https://www.instagram.com/thehaystyle.id/',
  facebook: 'https://www.facebook.com/HayStyle.id',
  whatsApp: 'https://api.whatsapp.com/send?phone=+62%20812-1480-4531',
};

export default SOSMED;